const Spinner = () => {
  return (
    <button className="btn btn-square loading"></button>
  )
}
export default Spinner